import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuexPersist from 'vuex-persist';
import localForage from 'localforage';

const vuexStorage = new VuexPersist({
  key: 'sourcelink',
  storage: localForage,
})

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [vuexStorage.plugin],
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user:  localStorage.getItem('user') || '',
    role:  localStorage.getItem('role') || '',
    fullname:  localStorage.getItem('fullname') || '',
    codrep: localStorage.getItem('codrep') || '',
  },
  mutations: {
    auth_request(state) {
      state.status = 'Carregando'
    },
    auth_success(state, token, user, role, fullname, codrep) {
      state.status = 'success'
      state.token = token
      state.user = user
      state.role = role
      state.fullname = fullname
      state.codrep   = codrep
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.user = ''
      state.role = ''
      state.codrep = ''
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: 'https://portal.pikolin.ind.br:4000/api/login', data: user, method: 'POST' })
          .then(resp => {

            const  token = resp.data.token
            const  role = resp.data.role
            const  user = resp.data.user['username']
            const  fullname = resp.data.fullname
            const  codrep   = resp.data.user['codrep']

            localStorage.setItem('token', token)
            localStorage.setItem('user', user)
            localStorage.setItem('role', role)
            localStorage.setItem('fullname', fullname)
            localStorage.setItem('codrep', codrep)
            axios.defaults.headers.common['Authorization'] = token

            commit('auth_success', token, user, role, fullname, codrep)

          }).then(res => {
            resolve(res) 
          })
           
          
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('role')
            localStorage.removeItem('fullname')
            localStorage.removeItem('codrep')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('role')
        localStorage.removeItem('fullname')
        localStorage.removeItem('codrep')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    isAdmin: state => state.role === "ADMIN",
    isRepres: state => state.role === "REPRES",
    isGerente: state => state.role === "GERENTE",
    getFullname: state => state.fullname,
    getCodrep: state => state.codrep,
  }
})